import { render } from "./NFTCard.vue?vue&type=template&id=05dd042b&scoped=true&ts=true"
import script from "./NFTCard.vue?vue&type=script&lang=ts"
export * from "./NFTCard.vue?vue&type=script&lang=ts"

import "./NFTCard.vue?vue&type=style&index=0&id=05dd042b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\deadsouls-staking\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dd042b"]])

export default __exports__